__turbopack_context__.v({
  "author-follow": "FollowButton-module__9lJV1G__author-follow",
  "author-follow-text": "FollowButton-module__9lJV1G__author-follow-text",
  "author-info-icon": "FollowButton-module__9lJV1G__author-info-icon",
});
